import { t } from 'i18next';

import { FormSubmissionResTypes, TFormData } from '#/client';
import { createBasicFormConfig } from '#/components/Form';
import Form from '#/components/Form/Form';
import tempPromoStore from '#/components/PlanPicker/tempPromoStore';
import {
  formDataToCreditCard,
  getPaymentInputFields,
} from '#/plugins/paywall/components';
import { ignoreError } from '#/service/utils';
import { generalModalStoreActions } from '#/store/modals';

import { usePaymentContext } from '../context';

const PaymentCardForm = () => {
  const {
    actions: { purchase },
    callPaymentAnalytics,
    isCardRequired,
    onPaymentChange,
    selectedPlan,
    customParameters = {},
    voucher,
  } = usePaymentContext();

  const submitForm = (formData: TFormData) => {
    const planId = selectedPlan?.id ?? '';
    const card = formDataToCreditCard(formData);
    const promoDetails = tempPromoStore.read();
    const params = {
      ...customParameters,
      ...(promoDetails.customSubscriptionParameters ?? {}),
    };

    return purchase(planId, {
      card,
      voucherCode: voucher,
      customParameters: params,
      startDate: promoDetails.startDate,
      customOrderParameters: promoDetails.customOrderParameters,
    })
      .then((res) => {
        // `res` here contains the actual price paid, order id, renewal date, etc.
        console.debug(
          'Payment successful, potentially finalized externally.',
          res
        );
        onPaymentChange({ isSuccessful: true, isExternal: res.isExternal });

        callPaymentAnalytics().catch(ignoreError);
        tempPromoStore.remove();

        return { _meta: { type: FormSubmissionResTypes.SUCCESS } };
      })
      .catch((err) => {
        console.error('Payment error', err);
        // show modal error. don't do anything on dismiss, just stay on paywall.
        generalModalStoreActions.showModal({
          title: t('iap.error.title'),
          message: t('iap.error.message'),
        });

        return {
          _meta: { type: FormSubmissionResTypes.ERROR, ignoreError: true },
        };
      });
  };

  const inputGroups = createBasicFormConfig(
    'payment',
    getPaymentInputFields(isCardRequired),
    {
      submit: {
        // TODO: handle one-off purchases in the plugin and Plan interface properly, temporary workaround for Rural's use-case to avoid changing plugins
        textKeyPath:
          selectedPlan?.duration.count === 1
            ? 'web.iap.subscribe.button'
            : 'web.iap.purchase.button',

        onClick: submitForm,
        disclaimer: t('web.iap.disclaimer'),
      },
    }
  );

  return <Form inputGroups={inputGroups} />;
};

export default PaymentCardForm;
